export default class GetConvocatoriaBySubtipoAndId {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idSubTipo, idConvocatoria) {
    try {
      const result = await this.#repository.getConvocatoriaBySubtipoAndId(idSubTipo, idConvocatoria)
      return result
    } catch (error) {
      console.error('Error al obtener la convocatoria por subtipo:', error)
      throw error
    }
  }
}
